export const DEFAULT_ERROR_MESSAGE = "There was an error";
export const DEFAULT_ACTION_ERROR = (action: string) =>
  `Incurred an error when ${action}`;
